export const TOKEN_LOCAL_STORAGE_KEY = 'cfToken';

export const getCurrentStoredToken = (): string | null => {
  try {
    const tokenFromStorage = localStorage.getItem(TOKEN_LOCAL_STORAGE_KEY);

    if (tokenFromStorage) {
      return tokenFromStorage;
    }
  } catch {}

  return null;
};

export const unsetCurrentStoredToken = (): void => {
  if (typeof window === 'undefined') {
    return;
  }

  window.localStorage.removeItem(TOKEN_LOCAL_STORAGE_KEY);
};

export const setCurrentStoredToken = (token?: string): void => {
  if (typeof window === 'undefined') {
    return;
  }

  if (!token) {
    unsetCurrentStoredToken();

    return;
  }

  window.localStorage.setItem(TOKEN_LOCAL_STORAGE_KEY, JSON.stringify(token));
};
